module.exports = __webpack_public_path__ + "media/images/dashboard-d2cd1b7bf8ccb79560c69f28d0be9375.svg";